import React, { useState, useEffect } from "react";
import stars_image from "assets/icons/star_img.svg";
import SaddleTable from "./SaddleTable";
import { gql, useQuery } from "@apollo/client";
import { GET_USER_TRANSACTIONS } from "apollo/queries/userTransactions";
import { LIST_MY_CUSTOM_SADDLE_ORDERS } from "apollo/mutations/customSaddleOrderRequest";
import "./style.css";
import Loader from "components/Spinners/Loader";

const MyOrders = () => {
  const { data: transData, loading: transLoading } = useQuery(gql(GET_USER_TRANSACTIONS), {
    fetchPolicy: "network-only",
  });

  const { data: customData, loading: customLoading } = useQuery(LIST_MY_CUSTOM_SADDLE_ORDERS, {
    fetchPolicy: "network-only",
  });

  const [activeTab, setActiveTab] = useState("standard");
  const [standardOrders, setStandardOrders] = useState({
    boughtSaddles: [],
    soldSaddles: [],
  });
  const [customOrders, setCustomOrders] = useState([]);

  useEffect(() => {
    const sortByDate = (a, b) => new Date(b.createdAt) - new Date(a.createdAt);

    if (transData) {
      const { boughtSaddles, soldSaddles } = transData.getUserTransactions;
      setStandardOrders({
        boughtSaddles: [...boughtSaddles].sort(sortByDate),
        soldSaddles: [...soldSaddles].sort(sortByDate),
      });
    }

    if (customData) {
      const items = customData.listMyCustomSaddleOrders?.items || [];
      setCustomOrders([...items].sort((a, b) => Number(b.createdAt) - Number(a.createdAt)));
    }
  }, [transData, customData]);

  const loading = transLoading || customLoading;

  return (
    <div className="w-[100%] mx-auto mb-[63px] min-h-screen">
      <div className="w-[90%] xl:max-w-[1300px] flex flex-col justify-between mx-auto pt-[121px]">
        <div className="flex flex-col md:flex-row justify-between items-end gap-6 mb-10">
          <div>
            <h1 className="buy_and_sell_title">My Orders</h1>
            <p className="buy_and_sell_subtitle max-w-[500px]">
              Manage your standard saddle transactions and track your custom saddle manufacturing requests in one place.
            </p>
            <img src={stars_image} alt="stars" className="mt-4" />
          </div>

          <div className="flex bg-[#F1F1F0] p-1 rounded-xl self-start md:self-end">
            <button
              onClick={() => setActiveTab("standard")}
              className={`px-3 py-1.5 sm:px-6 sm:py-2.5 rounded-lg text-xs sm:text-sm lg:text-base font-bold font-montserrat transition-all duration-300 ${activeTab === "standard"
                ? "bg-white text-[#2B364B] shadow-sm"
                : "text-gray-500 hover:text-gray-700"
                }`}
            >
              Standard Orders
            </button>
            <button
              onClick={() => setActiveTab("custom")}
              className={`px-3 py-1.5 sm:px-6 sm:py-2.5 rounded-lg text-xs sm:text-sm lg:text-base font-bold font-montserrat transition-all duration-300 ${activeTab === "custom"
                ? "bg-white text-[#2B364B] shadow-sm"
                : "text-gray-500 hover:text-gray-700"
                }`}
            >
              Custom Requests
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-[400px] w-full mt-20">
          <Loader
            filledColor="#2b364b"
            className="!h-[60px] !flex !items-center !text-center !justify-center"
          />
        </div>
      ) : (
        <div className="w-[90%] xl:max-w-[1300px] mx-auto transition-all duration-500">
          <SaddleTable
            activeTab={activeTab}
            boughtSaddles={standardOrders.boughtSaddles}
            soldSaddles={standardOrders.soldSaddles}
            customRequests={customOrders}
          />
        </div>
      )}
    </div>
  );
};

export default MyOrders;
